import { render } from "./AvioBertoli.vue?vue&type=template&id=c60a543e&scoped=true"
import script from "./AvioBertoli.vue?vue&type=script&lang=js"
export * from "./AvioBertoli.vue?vue&type=script&lang=js"

import "./AvioBertoli.vue?vue&type=style&index=0&id=c60a543e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c60a543e"]])

export default __exports__